{
	"columns":[
        {
			"header_id": "providerId",
			"header_label": "Provider ID",
			"jsonpath":  "providerId" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
        {
			"header_id": "tasTimesheetheaderDetailId",
			"header_label": "TimeSheet ID",
			"jsonpath":  "tasTimesheetheaderDetailId" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
        {
			"header_id": "payrollStartDate",
			"header_label": "From Date",
			"jsonpath":  "payrollStartDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "payrollEndDate",
			"header_label": "To Date",
			"jsonpath":  "payrollEndDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "grossAmount",
			"header_label": "Gross Amount",
			"jsonpath":  "grossAmount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "chequeAmount",
			"header_label": "Check Amount",
			"jsonpath":  "chequeAmount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "chequeNumber",
			"header_label": "Check Number",
			"jsonpath":  "chequeNumber" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "paidDate",
			"header_label": "Payment Date",
			"jsonpath":  "paidDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "providerTimesheet.json",
	"pageName": "providertimesheetlist2",
	"orderByColumn": ["tasTimesheetheaderDetailId"],
	"orderBy": ["desc"]
}